export default {
    formatNumber: function(value, decimals = 0) {
        let locale = 'en-US'
        let options = { maximumFractionDigits: decimals }

        return new Intl.NumberFormat(locale, options).format(value)
    }
}